var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "updatePwd" }, [
    _c(
      "div",
      { staticClass: "update-pwd-layout" },
      [
        _c("p", { staticClass: "title" }, [_vm._v("设置新密码")]),
        _vm._v(" "),
        _c("p", { staticClass: "remark-text" }, [
          _vm._v(
            "您的密码安全性太低，请按密码设置提示信息设置安全性高的新密码。"
          )
        ]),
        _vm._v(" "),
        _c(
          "el-form",
          {
            ref: "pwdForm",
            staticClass: "pwd_form",
            attrs: {
              autocomplete: "on",
              "label-position": "left",
              model: _vm.form,
              rules: _vm.formRules
            }
          },
          [
            _c(
              "div",
              { staticClass: "pwd_div" },
              [
                _c("p", { staticClass: "ele-title" }, [_vm._v("新密码")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { prop: "newPwd" } },
                  [
                    _c(
                      "span",
                      { staticClass: "svg-container" },
                      [_c("svg-icon", { attrs: { "icon-class": "password" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-input", {
                      ref: "newPwd",
                      attrs: {
                        type: "password",
                        placeholder:
                          "8位及以上，包含字母、数字和特殊符号!@#¥$%^&*~\\.，字母区分大小写",
                        tabindex: "1",
                        autocomplete: "off",
                        minlength: 6,
                        maxlength: 30
                      },
                      model: {
                        value: _vm.form.newPwd,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "newPwd", $$v)
                        },
                        expression: "form.newPwd"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pwd_div" },
              [
                _c("p", { staticClass: "ele-title" }, [_vm._v("确认新密码")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { prop: "confirmPwd" } },
                  [
                    _c(
                      "span",
                      { staticClass: "svg-container" },
                      [_c("svg-icon", { attrs: { "icon-class": "password" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-input", {
                      ref: "confirmPwd",
                      attrs: {
                        type: "password",
                        placeholder:
                          "8位及以上，包含字母、数字和特殊符号!@#¥$%^&*~\\.，字母区分大小写",
                        tabindex: "1",
                        autocomplete: "off",
                        minlength: 6,
                        maxlength: 30
                      },
                      model: {
                        value: _vm.form.confirmPwd,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "confirmPwd", $$v)
                        },
                        expression: "form.confirmPwd"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "big-btn",
                attrs: { type: "primary", disabled: _vm.isReset },
                on: { click: _vm.resetPWDFn }
              },
              [_vm._v("确认修改")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }